import React from "react";
import styled from "styled-components";
import { ReactComponent as BellIcon } from "../../Assets/icons/bell.svg";
import { useTranslate } from '@tolgee/react';
import PrimaryButtonRemove from "./PrimaryButtonRemove";
import PrimaryButton from "./PrimaryButton";

const RequestNotificationsModal = ({
  handleClose,
  handleRequestNotificationsPermission,
}) => {
  const { t } = useTranslate();
  if (window.isElectron) {
    return
  }
  return (
    <FullScreenItem>
      <Card>
        <Line style={{ alignItems: "leading" }}>
          <BellIcon />
          <Title>{t('request_notifications_modal.title')}</Title>
        </Line>

        <Line>
          <InfoText>
            {t('request_notifications_modal.info')}
          </InfoText>
        </Line>
        <Line>
          <PrimaryButtonRemove outlined onClick={() => handleClose()} style={{ padding: '16px', width: "100%" }}>
            {t('general.cancel')}
          </PrimaryButtonRemove>
          <PrimaryButton onClick={() => handleRequestNotificationsPermission()} style={{ padding: '16px', width: "100%" }}>
            {t('general.enable')}
          </PrimaryButton>
        </Line>
      </Card>
    </FullScreenItem>
  );
};

export default RequestNotificationsModal;

const FullScreenItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  left: 0;
  top: 0;
  z-index: 1;
`;
const Card = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 200px;
  max-width: 500px;
  width: 100%;
 background:${({ theme }) => theme.menu.background};
  border-radius: 4px;
  padding: 30px;
  align-items: center;
  position: relative;
  gap: 20px;
`;
const Line = styled.div`
  display: flex;
  width: 100%;
  gap: 20px;
  svg {
    max-height: 40px;
    width: fit-content;
  }
`;
const InfoText = styled.h1`
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
`;
const Title = styled.h1`
  margin-top: 6px;
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
 color: ${({ theme }) => theme.menu.secondaryTextColor};
`;

